import React from "react";
import { Dropdown as AntdDropdown } from "antd";

const Dropdown = ({ children, items = [], ...rest }) => {
  return (
    <AntdDropdown menu={{ items }} trigger={["click"]} {...rest}>
      {children}
    </AntdDropdown>
  );
};

export default Dropdown;
